__turbopack_context__.v({
  "compact": "styles-module__CrvoCq__compact",
  "moon": "styles-module__CrvoCq__moon",
  "sun": "styles-module__CrvoCq__sun",
  "sun-and-moon": "styles-module__CrvoCq__sun-and-moon",
  "sun-beams": "styles-module__CrvoCq__sun-beams",
});
